import type { PropsWithChildren } from "react";

import styles from "./BulletList.module.css";

interface BulletListProps extends PropsWithChildren {}

export function BulletList({ children }: BulletListProps) {
  return <ul className={styles.bulletList}>{children}</ul>;
}
